<div class="card">
  <h5 class="card-header">Monitoring</h5>
  <div class="card-body">
    <iframe id='monitoringIframe' frameborder="0" style="width: 100%; min-height: 100vh;"></iframe>
  </div>
</div>
